export const width = 960
export const height = 640

export const center = { x: width / 2, y: height / 2 }

export const yearCenters = {
  2008: { x: width / 4, y: height / 2 },
  2009: { x: width / 2, y: height / 2 },
  2010: { x: (3 / 4) * width, y: height / 2 },
}



// WEBPACK FOOTER //
// ./src/articles/d3-bubblechart/constants.js